module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0691.81426277.jpg";